import * as React from 'react';
import ServiceProxy from '../services/ServiceProxy'

/* tslint:disable:no-unused-variable */
import { DefaultButton, IconButton } from 'office-ui-fabric-react/lib/Button';
import { CommandBar, ICommandBarItemProps } from 'office-ui-fabric-react/lib/CommandBar';
import { MessageBar, MessageBarType } from 'office-ui-fabric-react/lib/MessageBar';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import {
    DetailsRow
} from 'office-ui-fabric-react/lib/DetailsList';
import { FocusZone } from 'office-ui-fabric-react/lib/FocusZone';
import {
    Selection,
    SelectionMode
} from 'office-ui-fabric-react/lib/utilities/selection/index';
import {
    HoverCard,
    IExpandingCardProps,
    ExpandingCardMode
} from 'office-ui-fabric-react/lib/HoverCard';
import {
    GroupedList,
    IGroup,
    IGroupDividerProps
} from 'office-ui-fabric-react/lib/GroupedList';
/* tslint:enable:no-unused-variable */

import KeycloakService from '../services/KeycloakService';

export interface LanguageItem {
    id: string;
    name: string;
    text: string;
    prefix: string;
}

export interface LanguageListProps {
    keycloakClient: KeycloakService;
    documentId: string;
}

export interface ILanguageListState {
    selectedText: string;
    languageItems: Array<LanguageItem>;
    formDataItems: Array<LanguageItem>;
    insertionText: string;
    errors: Array<string>;
}

export default class LanguageList extends React.Component<LanguageListProps, ILanguageListState> {
    constructor(props: LanguageListProps) {
        super(props);
        this._onRenderCell = this._onRenderCell.bind(this);
        this._onRenderItemColumn = this._onRenderItemColumn.bind(this);
        this._onChangeText = this._onChangeText.bind(this);
        this.applyFormData = this.applyFormData.bind(this);
        this._loadLanguageLibrary = this._loadLanguageLibrary.bind(this);

        this.state = {
            selectedText: '',
            languageItems: [],
            formDataItems: [],
            insertionText: '',
            errors: []
        };
    }

    private _selection: Selection = new Selection();

    render() {
        let filteredLanguageItems: Array<LanguageItem> = [];
        let filteredFormDataItems: Array<LanguageItem> = [];

        if (this.state.selectedText.length > 0) {
            filteredLanguageItems = this.state.languageItems.filter((item) => { return item.name.toLowerCase().indexOf(this.state.selectedText.toLowerCase()) >= 0; });
            filteredFormDataItems = this.state.formDataItems.filter((item) => { return item.name.toLowerCase().indexOf(this.state.selectedText.toLowerCase()) >= 0; });
        } else {
            filteredLanguageItems = this.state.languageItems.slice(0);
            filteredFormDataItems = this.state.formDataItems.slice(0);
        }

        let _items: Array<LanguageItem> = filteredLanguageItems.concat(filteredFormDataItems);
        let _groups: IGroup[] = this._getGroups(filteredLanguageItems, filteredFormDataItems);

        const headerProps: IGroupDividerProps = {
            indentWidth: 0
        };

        return (
            <div className='mt-languageList'>
                {this.state.errors.length > 0 && this.displayErrors()}
                <CommandBar items={this.getCommandBarItems()} />
                <div className='mt-languageList__search' >
                    <TextField
                        placeholder='Find by name in lists below:'
                        ariaLabel='Search box for filtering list results below'
                        onChanged={this._onChangeText}
                        iconProps={{ iconName: 'Search' }}
                    />
                </div>
                <FocusZone>
                    <GroupedList
                        items={_items}
                        className='mt-languageList__groupedList'
                        onRenderCell={this._onRenderCell}
                        selection={this._selection}
                        selectionMode={SelectionMode.none}
                        groups={_groups}
                        groupProps={{
                            headerProps: headerProps,
                            showEmptyGroups: true
                        }}
                    />
                </FocusZone>
            </div>
        );
    }

    componentDidMount() {
        this._loadLanguageLibrary();
    }

    _loadLanguageLibrary() {
        this.setState({ errors: [] });

        const serviceProxy: ServiceProxy = new ServiceProxy({
            keycloakClient: this.props.keycloakClient,
        });

        if (this.props.documentId !== '') {
            serviceProxy.getLanguageList(this.props.documentId)
                .then(res => {
                    console.log(res);
                    const terms = res.data.map((value) => {
                        return {
                            id: value.id,
                            name: value.name,
                            text: value.text,
                            prefix: 'AL'
                        };
                    }).sort(this._languageItemSorter);
                    this.setState({ languageItems: terms });
                })
                .catch(function (error) {
                    let errors = this.state.errors;
                    errors.push('Failed loading approved language.')
                    this.setState({ errors: errors });
                    console.log('Error: ' + JSON.stringify(error));
                }
                    .bind(this));

            serviceProxy.getFormData(this.props.documentId)
                .then(res => {
                    console.log(res);
                    const formData = res.data["field-values"].map((value) => {
                        return {
                            id: value.id,
                            name: value.name,
                            text: this._formatValue(value["input-val"]),
                            prefix: 'FD'
                        }
                    }).sort(this._languageItemSorter);
                    this.setState({ formDataItems: formData });
                })
                .catch(function (error) {
                    let errors = this.state.errors;
                    errors.push('Failed loading form data.')
                    this.setState({ errors: errors });
                    console.log('Error: ' + JSON.stringify(error));
                }.bind(this));
        }
    }

    _languageItemSorter(first:LanguageItem, second:LanguageItem) : number {
        return first.name.toLocaleLowerCase().localeCompare(second.name.toLocaleLowerCase());
    }

    private _formatValue(val: any): string {
        if (Array.isArray(val)) {
            return val.join(', ');
        }
        return val.toString();
    }

    applyFormData() {
        this.state.formDataItems.forEach(this.mergeItemData);
        this.state.languageItems.forEach(this.mergeItemData);
    }

    async mergeItemData(item: LanguageItem) {

        await Word.run(async (context) => {
            // Queue a command to search the document for any string of characters after 'ly'.
            let searchString: string = '[' + item.prefix + ':' + item.name.trim().toUpperCase().replace(/\s+/g, '_').replace(/\W/g, '') + ']';
            console.log('Searching for:' + searchString);
            var searchResults = context.document.body.search(searchString, { matchCase: true });

            // Queue a command to load the search results and get the font property values.
            context.load(searchResults);

            // Synchronize the document state by executing the queued commands, 
            // and return a promise to indicate task completion.
            return context.sync().then(function () {
                console.log('Found count: ' + searchResults.items.length);

                // Queue a set of commands to change the font for each found item.
                for (var i = 0; i < searchResults.items.length; i++) {
                    searchResults.items[i].insertText(item.text, Word.InsertLocation.replace);
                }

                // Synchronize the document state by executing the queued commands, 
                // and return a promise to indicate task completion.
                return context.sync();
            });
        })
        .catch((error) => {
            console.log('Error: ' + JSON.stringify(error));
            if (error instanceof OfficeExtension.Error) {
                console.log('Debug info: ' + JSON.stringify(error.debugInfo));
            }
        });
    }

    runInsert = async () => {

        await Word.run(async (context) => {
            if (this.state.insertionText.length > 0) {
                // Create a proxy object for the document.
                var thisDocument = context.document;

                // Queue a command to get the current selection.
                // Create a proxy range object for the selection.
                var range = thisDocument.getSelection();
                range.insertText(this.state.insertionText, Word.InsertLocation.replace);
            }
            await context.sync();
        })
            .catch(function (error) {
                console.log('Error: ' + JSON.stringify(error));
                if (error instanceof OfficeExtension.Error) {
                    console.log('Debug info: ' + JSON.stringify(error.debugInfo));
                }
            });
    }

    handleTextInsertion = (selection: string) => {
        this.setState({
            insertionText: selection
        });
        this.runInsert();
    }

    private displayErrors() {
        return (
            this.state.errors.map((e) =>
                <MessageBar
                    messageBarType={MessageBarType.error}
                    isMultiline={false}
                    dismissButtonAriaLabel='Close'>
                    {e}
                </MessageBar>));
    }

    private getCommandBarItems(): Array<ICommandBarItemProps> {
        let items = [{
            key: 'refreshListsCommand',
            onClick: this._loadLanguageLibrary,
            name: 'Refresh',
            iconOnly: true,
            iconProps: { iconName: 'Refresh' }
        }];
        if (this.state.formDataItems.length > 0) {
            items.push({
                key: 'formDataCommand',
                onClick: this.applyFormData,
                name: 'Merge Form Data',
                iconOnly: true,
                iconProps: { iconName: 'DecreaseIndentLegacy' }
            });
        }
        return items;
    }

    private _onChangeText(newValue: string) {
        if (newValue !== this.state.selectedText &&
            (newValue.length > 2 || newValue.length === 0)) {
            this.setState({ selectedText: newValue });
        }
    }

    private _onRenderCell(nestingDepth: number, item: LanguageItem, itemIndex: number): JSX.Element {
        const indentWidth: number = 0;
        return (
            <DetailsRow
                columns={[{
                    key: item.id,
                    name: 'Name',
                    fieldName: 'name',
                    minWidth: 300,
                    isResizable: true,
                    isSortedDescending: false,
                    data: 'string',
                    isPadded: false,
                    className: 'mt-languageList__listColumn'
                }]}
                compact={false}
                onRenderItemColumn={this._onRenderItemColumn}
                groupNestingDepth={nestingDepth}
                indentWidth={indentWidth}
                item={item}
                itemIndex={itemIndex}
                selection={this._selection}
                selectionMode={SelectionMode.none}
                className='mt-languageList__listItem'
            />
        );
    }

    private _onRenderItemColumn(item?: LanguageItem, itemIndex?: number) {
        const expandingCardProps: IExpandingCardProps = {
            onRenderCompactCard: this._onRenderCompactCard,
            onRenderExpandedCard: this._onRenderExpandedCard,
            expandedCardHeight: 40,
            mode: ExpandingCardMode.expanded,
            renderData: item,
            styles: {
                root: {
                    width: 290
                },
                expandedCard: {
                    overflowY: 'visible'
                }
            }
        };

        return (
            <div className='mt-languageList__listItem' data-is-focusable={true}>
                <div className='mt-languageList__listItemContent' data-indexabc={itemIndex}>
                    <div className='mt-languageList__listItemName'>{item.name} </div>
                    <HoverCard
                        id='myID1'
                        expandingCardProps={expandingCardProps}
                        instantOpenOnClick={true}
                        className='mt-languageList__listItemPreview'>
                        <div data-is-focusable={true}>
                            <IconButton
                                disabled={false}
                                checked={false}
                                iconProps={{ iconName: 'RedEye' }}
                                ariaLabel="Preview"
                            />
                        </div>
                    </HoverCard>
                    <IconButton
                        disabled={false}
                        checked={false}
                        iconProps={{ iconName: 'CirclePlus' }}
                        title="Insert"
                        ariaLabel="Insert"
                        onClick={() => this.insertText(item.text)}
                    />
                    {/* <DefaultButton
                        className='mt-languageList__listItemButton'
                        primary={true}
                        text='Insert'
                        onClick={() => this.insertText(item.text)}
                    /> */}
                </div>
            </div>);
    }

    private _onRenderCompactCard = (item: LanguageItem): JSX.Element => {
        return (
            <div className='mt-languageList__listItemPreview_compactCard'>
                {item.text}
            </div>
        );
    };

    private _onRenderExpandedCard = (item: LanguageItem): JSX.Element => {
        return (
            <div className='mt-languageList__listItemPreview_extendedCard'>
                <DefaultButton
                    primary={true}
                    text='Insert'
                    onClick={() => this.insertText(item.text)}
                />
            </div>
        );
    };

    public insertText(text: string) {
        this.handleTextInsertion(text);
        console.info(text);
    }

    private _getGroups(languageItems: Array<LanguageItem>, formDataItems: Array<LanguageItem>): Array<IGroup> {
        let groups: Array<IGroup> = [{
            count: languageItems.length,
            key: 'languageLibraryGroup',
            name: 'Approved Language Library',
            startIndex: 0,
            level: 1,
            isCollapsed: formDataItems.length > 0            
        }];

        if (formDataItems.length > 0) {
            groups.push({
                count: formDataItems.length,
                key: 'formDataGroup',
                name: 'Form Data',
                startIndex: languageItems.length,
                level: 1,
                isCollapsed: false
            });
        }
        return groups;
    }   
}



// WEBPACK FOOTER //
// ./components/LanguageList.tsx